<template>
	<div class="assets-composition-wrapper" :class="{ 'chart-wrapper-inline': inline }">
		<Loading v-if="loading"/>
		<div class="text-center" v-if="loading === false && report.length === 0">
			<small class="text-grey">Graf Polaris neobsahuje žiadne dáta.</small>
		</div>
		<template v-if="loading === false && report.length !== 0">
			<div
				class="chart-wrapper"
				:class="{ 'chart-wrapper-inline': inline }"
				:style="'width: ' + size + 'px; height: ' + size + 'px'"
			>
				<vue-chart
					ref="chart"
					type="doughnut"
					:data="chartData"
					:options="options"
					:height="size"
					:width="size"
				></vue-chart>
			</div>
			<div class="legend-wrapper legend-wrapper-polaris c-pointer">
				<ul>
					<li v-for="(item, index) in report" v-bind:key="item.type" @click="openSlice(index);">
						<span class="dot" :style="'background-color: ' + getColor(index)"></span>
						<span class="name">{{ item.type }}</span>
						<span class="percent" :title="item.share">{{ item.share | number(0) }} %</span>
					</li>
				</ul>
			</div>
		</template>
	</div>
</template>
<script>
import VueChart from "vue-chart-js";
import Loading from "./Loading";

export default {
	name: "AssetsComposition",
	components: {
		Loading,
		VueChart,
	},
	props: {
		size: {
			type: Number,
			default: 140,
		},
		inline: {
			type: Boolean,
			default: true,
		},
		selectable: {
			type: Boolean,
			default: false,
		},
		state: {
			type: String,
		},
	},
	watch: {
		report: {
			deep: true,
			handler() {
				this.initGraph();
			},
		},
	},
	computed: {
		report() {
			return this.$store.state.assets[this.state];
		},
		loading() {
			return this.$store.state.assets.loading;
		},
	},
	mounted() {
		this.$store.dispatch("assets/" + this.state);
		setTimeout(() => {
			this.openSlice(0);
		}, 1800);
	},
	methods: {
		getColor(index) {
			const colors = this.colors.length;
			const iterations = Math.floor(index / colors);
			const colorIndex = index - iterations * colors;
			return this.colors[colorIndex];
		},
		initGraph() {
			this.totalPrice = 0;
			this.chartData.labels = [];
			this.chartData.datasets[0].data = [];
			this.chartData.datasets[0].backgroundColor = [];

			this.report.forEach((item, index) => {
				this.chartData.labels.push(item.type);
				this.chartData.datasets[0].data.push(item.share);
				this.chartData.datasets[0].backgroundColor.push(this.getColor(index));
			});
		},
        handleGraphHover(evt) {
            const point = this.$refs.chart.chart.getElementAtEvent(evt);
            if (point.length) {
                evt.target.style.cursor = 'pointer';
            }
        },
		handleGraphClick(evt) {
			const activeElement = this.$refs.chart.chart.getElementAtEvent(evt);
			if (activeElement[0] !== undefined) {
				this.openSlice(activeElement[0]._index);
			}
		},
		openSlice(sliceIndex) {
			if (this.selectable === true) {
				const chart = this.$refs.chart.chart;
				chart.update();
				const meta = chart.data.datasets[0]._meta;
				const slices = meta[Object.keys(meta)[0]].data;
				if (slices[sliceIndex]) {
					const sliceModel = slices[sliceIndex]._model;
                    sliceModel.outerRadius += 13;
                    sliceModel.innerRadius += 10;
				}
			}
		},
        getName(name) {
            const i = name.indexOf("/");
            if (i > 0) {
                return name.slice(0, i) + '/ ' + name.slice(i + 1, name.length);
            } else {
                return name;
            }

        }
	},
	data() {
		return {
			chartData: {
				labels: [],
				datasets: [
					{
						data: [],
						backgroundColor: [],
						borderWidth: 0
					},
				],
			},
			options: {
				responsive: true,
				cutoutPercentage: 70,
				legend: false,
				title: false,
				tooltips: false,
				hover: {
					mode: null,
                    onHover: this.handleGraphHover
				},
				animation: {
					animateScale: true,
					animateRotate: true,
				},
				onClick: this.handleGraphClick,
				layout: {
					padding: this.inline ? 5 : 15,
				}
			},
            colors: ["#bbcf2c", "#058dcc", "#6e548d", "#818181", "#ebebeb", "#13516e"],
		};
	},
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.legend-wrapper-polaris {
    max-width: 280px !important;
}
</style>
